import React from 'react'
import { useRecoilValue } from 'recoil'
import { useIntl } from 'react-intl'

import {
  Icon60FileCode,
  Panel,
  PANEL_SPACING_VARIANT_SECONDARY,
  Flex,
  FlexItem,
  TEXT_VARIANT_BOLD,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import {
  IconWrapperLarge,
  StyledText
} from '../commonComponents/commonComponents'

import { messageState } from 'Pages/MessageCheckupSummary/recoil/state/message'

const PotentialCount = () => {
  const intl = useIntl()
  const {
    checkup: { potentialCount, potentialTotal }
  } = useRecoilValue(messageState)

  return (
    <Panel spacingVariant={PANEL_SPACING_VARIANT_SECONDARY}>
      <Flex
        alignItems='flex-start'
        justifyContent='flex-start'
        columnGap='32px'
      >
        <FlexItem>
          <IconWrapperLarge>
            <Icon60FileCode />
          </IconWrapperLarge>
        </FlexItem>

        <FlexItem>
          <StyledText variant={TEXT_VARIANT_BOLD} htmlElement='span'>
            {potentialCount}
          </StyledText>
          {`/ ${potentialTotal}`}
          <Title variant={TITLE_VARIANT_M}>
            {intl.formatMessage({ id: 'Load.EmailCheckUp.Critique' })}
          </Title>
        </FlexItem>
      </Flex>
    </Panel>
  )
}

export default PotentialCount
